import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { CheckIfRecipeIsLockedInput } from './CheckIfRecipeIsLockedInput';
import { CheckIfRecipeIsLockedOutput } from './CheckIfRecipeIsLockedOutput';

export class CheckIfRecipeIsLockedService extends HttpServiceBase {

  handle = (input: CheckIfRecipeIsLockedInput): Promise<Result<CheckIfRecipeIsLockedOutput> | null> => {
    const promise = this.http.put<Result<CheckIfRecipeIsLockedOutput>, CheckIfRecipeIsLockedInput>(
      `${this.baseUrlSislogApi}/v2/customer-recipe/check-if-locked`, input);
    return promise;
  }
}